// The SuperAdmin "SMS Spend" dashboard's call (backend/api/sms_spend.py): GET /api/admin/sms-spend/
// for what texting costs, read from Twilio's bill and its record of every text. It answers the
// admins the analytics gate admits, and sends the signed-in user's token (staffRequest).

import { getBackendURL } from "../components/env";
import { staffRequest } from "./staffRequest";

const PATH = "/api/admin/sms-spend/";
const UNREACHABLE = "The SMS spend couldn't be loaded. Try again.";

// The report for `days` up to today, or for `start`..`end` (YYYY-MM-DD, clinic time): the texts
// this database has a record of, or with `outside` every text on the Twilio account, that went
// `direction`: "outbound" (sent), "inbound" (received) or "all". `refresh` reads Twilio again
// instead of the copy the server keeps for five minutes.
export function fetchSmsSpend({ days = 30, start, end, outside = false, direction = "outbound", refresh = false } = {},
                              { signal } = {}) {
  const url = new URL(`${getBackendURL()}${PATH}`);
  if (start && end) {
    url.searchParams.set("start", start);
    url.searchParams.set("end", end);
  } else {
    url.searchParams.set("days", String(days));
  }
  if (outside) url.searchParams.set("outside", "1");
  url.searchParams.set("direction", direction);
  if (refresh) url.searchParams.set("refresh", "1");
  return staffRequest(url.toString(), { failure: UNREACHABLE, signal });
}
